<ion-app [ngClass]="getRouteClass(outlet)">
    <ion-router-outlet [animated]="false" #outlet></ion-router-outlet>
</ion-app>
